//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { axiosPost } from '../../../../axios/axios.js'
import UserPassword from './UserPassword.vue'
import { getEmployeePasswordRequirements, getPasswordConfiguration } from '../../../../forms/Employee/EmployeePasswordRequirements.js'
import Vue from 'vue'

export default {
  components: {
    UserPassword
  },
  props: {
    oldPasswordLabel: {
      type: String,
      default: 'СТАРЫЙ ПАРОЛЬ'
    }
  },
  data: function () {
    return {
      oldPassword: null,
      newPassword: null,
      repeatedNewPassword: null,
      oldPasswordRule: null,
      newPasswordRule: null,
      repeatedNewPasswordRule: null,
      passwordConfiguration: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    oldPasswordValid: function () {
      return this.oldPasswordRule(this.oldPassword)
    },
    newPasswordValid: function () {
      return !this.newPassword || this.newPassword === '' ? 'Поле не может быть пустым' : this.newPasswordRule(this.newPassword)
    },
    repeatedNewPasswordValid: function () {
      return !this.repeatedNewPassword || this.repeatedNewPassword === '' ? 'Поле не может быть пустым' : this.repeatedNewPasswordRule(this.repeatedNewPassword)
    }
  },
  created: async function () {
    this.passwordConfiguration = await getPasswordConfiguration()
    this.oldPasswordRule = (val) => {
      return !val || val === '' ? 'Поле не может быть пустым' : true
    }
    this.newPasswordRule = await getEmployeePasswordRequirements(this.user, this.passwordConfiguration)
    this.repeatedNewPasswordRule = (val, newPassword) => {
      if (!this.repeatedNewPassword || this.repeatedNewPassword === '') {
        return 'Поле не может быть пустым'
      } else {
        return val === newPassword ? true : 'Пароли не совпадают'
      }
    }
  },
  methods: {
    changePassword: function () {
      // debugger
      if (!this.$refs.oldPasswordField.validate() || !this.$refs.newPasswordField.validate() || !this.$refs.repeatedNewPasswordField.validate()) {
        return
      }

      const userProps = Object.assign({
        password: this.newPassword
      }, this.user.systemUser.properties)

      const bodyFormData = new FormData()
      bodyFormData.set('props', JSON.stringify(userProps))
      bodyFormData.set('password', this.oldPassword)
      bodyFormData.set('append', true)

      axiosPost({
        url: '/service/user/changeuser',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$refs.oldPasswordField.reset()
          this.$refs.newPasswordField.reset()
          this.$refs.repeatedNewPasswordField.reset()

          // for DeltaDialog
          Vue.nextTick(() => this.$emit('ok'))

          this.$q.notify({
            type: 'positive',
            message: 'Пароль успешно изменен',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (error) => {
          if (error.type === 'security') {
            this.$refs.oldPasswordField.setInvalid('Неверный пароль')
          }
          this.$q.notify({
            type: 'negative',
            message: error.message,
            progress: true,
            timeout: 8000
          })
        }
      })
    }
  }
}

